import {sendDesktopAnalyticsPerSession} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {sendMobileAnalyticsPerSession} from '@optimaxdev/analytics/mobile/lib/sendAnalyticsEvent/index';
import {initializeExperimentMethodsLib} from '@optimaxdev/utils';

import {GENERAL_EXPERIMENT_INDICATION} from 'constants/analytics/events/general';

import {flags} from './rollout';

export const {getRoxStringStateWithAnalytics, useExperiment} = initializeExperimentMethodsLib({
    event: GENERAL_EXPERIMENT_INDICATION,
    expIndicationAnalyticsFn:
        __BUILD_TYPE__ === 'desktop'
            ? sendDesktopAnalyticsPerSession
            : sendMobileAnalyticsPerSession,
    // @ts-expect-error
    flagsContainer: flags,
    isSSR: false,
});
